/**
 * Created by Joseph.Saliba on 3/21/15.
 */
namespace app.directives {
    export class Factory {
        public static Create(t:{ new(...args) }): angular.IDirective {
            return ((...args) => new (Function.bind.apply(t, [t, ...args]))()) as angular.IDirective;
        }
    }
}
